import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import { ReducerState } from '../../store.types';

export const feesConfigSelector = ({ feesConfig }: ReducerState) => feesConfig;
export const feesConfigLoadingSelector = createSelector(
  feesConfigSelector,
  ({ fetchStatus }) => fetchStatus === fetchStatuses.pending,
);
